/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class Step {
  private json: any
  public readonly uid: string
  public readonly description: string
  public readonly heading: string
  public readonly number: string

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.description = json.step_description
    this.heading = json.step_heading
    this.number = json.step_number
  }

  static of (json: any): Step {
    return new Step(json)
  }
}
